<template>
  <v-container>
    <!-- eslint-disable max-len -->
    <v-row>
      <v-col>
        <v-card flat class="mx-auto" max-width="344">
          <v-card-text>
            <p class="headline text-center font-weight-bold">Thank you for your time.</p>
          </v-card-text>
          <v-card-text>
            <p class="title primary--text text-center">We appreciate your feedback.</p>
            <p class="font-weight-regular text-center mt-12">
              You can now close your browser page or return to the
              <a target="_blank" :href="params.TodoListUrl">Resonate dashboard</a> to complete more
              360 feedback invitations (‘My To-Do - 360 Feedback’ tab) or access other feedback
              platforms including Net FollowerShip (NFS).
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <div class="ma-8">
        <img text-center alt="Powered by Resonate" src="@/assets/poweredbyresonate.svg" />
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Outro',

  data() {
    return {};
  },

  computed: {
    ...mapGetters(['currentStep']),
    params() {
      return this.$store.state.params;
    },
  },
};
</script>
